import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'

export const motorLetterResponseSchema = responseSchema(
  z.object({
    pdfBase64: z.string(),
    fileName: z.string(),
    contentType: z.string(),
    verificationCode: z.string(),
    verificationUrl: z.string()
  })
)

export type MotorLetterResponse = z.infer<typeof motorLetterResponseSchema>
